// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description Fetch Result Request Model for external polling API
*/
export class EServicesOrchestratorServicePublicNewPathModelsFetchResultRequestModel {
    /**
    * @description Transaction Correlation ID of the original request
    */
    'transactionCorrelationId': number;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof EServicesOrchestratorServicePublicNewPathModelsFetchResultRequestModel>> = [
        {
            "name":     "transactionCorrelationId",
            "baseName": "transactionCorrelationId",
            "type":     "number"
        },
    ];

    static getAttributeTypeMap() {
        return EServicesOrchestratorServicePublicNewPathModelsFetchResultRequestModel.attributeTypeMap;
    }
}
